import { useEffect, useState, useRef } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components/macro'
import debounce from 'lodash.debounce'
import { Input } from '.'
import { Icon } from '../layout'

const SearchIcon = styled(Icon)`
  position: absolute;
  left: 10px;
  top: 5px;
  z-index: 2;
  color: ${(props) => props.theme.textColors.lightgray};
`

const Search = styled('div')`
  display: inline-block;
  position: relative;
  margin: 0 1rem 0 0;
  width: 300px;

  ${Input} {
    padding-left: 2rem;
  }
`

const KeywordSearchField = (props) => {
  const { onChange, autoFocus } = props
  const [value, setValue] = useState(null)
  const { formatMessage } = useIntl()

  // Create debounced function once and store in ref to prevent recreation
  const debouncedOnChange = useRef(
    debounce((searchValue) => {
      // Only trigger search if value is empty (to clear results) or has at least 2 characters
      // Backend skips searches with less than 2 characters anyway
      if (searchValue === '' || searchValue.length >= 2) {
        onChange(searchValue)
      }
    }, 200)
  ).current

  useEffect(() => {
    if (value !== null) {
      debouncedOnChange(value)
    }
  }, [value, debouncedOnChange])

  const handleOnChange = (event) => {
    setValue(event.target.value)
  }

  return (
    <Search>
      <SearchIcon name="Search" size="sm" />
      <Input placeholder={formatMessage({ id: 'placeholder.search' })} onChange={handleOnChange} value={value || ''} autoFocus={autoFocus || false} />
    </Search>
  )
}

export default KeywordSearchField
